import {
  BusinessCenterRounded,
  ChecklistRtlRounded,
  FlightRounded,
  SchoolRounded,
  WorkHistoryRounded,
} from "@mui/icons-material";
import {
  Box,
  Breadcrumbs,
  Card,
  Grid,
  Stack,
  Tooltip,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import InsertLinkOutlinedIcon from '@mui/icons-material/InsertLinkOutlined';
import React, { useEffect, useRef,useState } from "react";
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useSelector,useDispatch } from "react-redux";
import { appSelector } from "../redux/selector";
import parse from "html-react-parser";
import moment from "moment";
import { styled, alpha } from "@mui/material/styles";
import LoadingSkeleton from "../loadingSkeletons/LoadingList";
import Loadingjobdetail from "../loadingSkeletons/Loadingjobdetail";

const Bullet = styled("span")({
  display: "inline-block",
  width: "3px",
  height: "3px",
  borderRadius: "50%",
  backgroundColor: "currentColor",
});

const JobDetails = ({ handleInputChange ,setSource  , setCandidateRole}) => {
  const {
    selectedCandidate,
    solrJobs,
    candidate,
    selectedJob,
    selectedSubmission,
    sendJobToCandidate,
    getSubmissionsByJobAction,
    filterJobsByCompany,
    jobDetails
  } = useSelector(appSelector);
  const gridRef = useRef(null);
  const skillMatchRef = useRef(null);
  const [copied, setCopied] = useState(false);
  const dispatch = useDispatch();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Mobile devices
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // Tablets
  const isDesktopSmall = useMediaQuery(theme.breakpoints.between("md", "lg")); // Small desktops
  const isDesktopLarge = useMediaQuery(theme.breakpoints.up("lg")); // Large desktops
  


  /* copy job detailsview started*/
  const handleCopy = () => {
    const copyText = generateCopyText(); // Implement this function to generate the text to copy
    if (copyText) {
      navigator.clipboard.writeText(copyText)
        .then(() => {
          setCopied(true);
          setTimeout(() => setCopied(false), 1500); // Reset copied state after 1.5 seconds
        })
        .catch((error) => console.error('Failed to copy:', error));
    }
  };

  const generateCopyText = () => {
    // Implement logic to generate the text to be copied
    let copyText = '';
    if (selectedJob) {
      copyText += `${selectedJob.jobtitle}\n`;
      copyText += `${selectedJob.company_name}\n`;
      copyText += `${selectedJob.location ? selectedJob.location : (parseInt(selectedJob.remote) === 1 ? "Remote" : "N/A")}\n`;
      copyText += `${selectedJob.posted_date !== undefined ? moment(selectedJob.posted_date).fromNow() : moment("2022-03-31T06:26:04.138Z").fromNow()}\n`;
      copyText += `Job Type: ${selectedJob.jobtype_name !== undefined && selectedJob.jobtype_name !== null ? selectedJob.jobtype_name : "Full Time"}\n`;
      copyText += `Visa Type: ${selectedJob.visatypeName !== undefined && selectedJob.visatypeName !== null ? selectedJob.visatypeName : "N/A"}\n`;
      copyText += `Qualifications: ${selectedJob.qualifications !== undefined && selectedJob.qualifications !== null && selectedJob.qualifications !== "" ? selectedJob.qualifications : "N/A"}\n`;
      copyText += `Experience: ${selectedJob.experience === "0" ? "0 - 3 Years" : selectedJob.experience}\n`;
      copyText += `Required Skills: ${selectedJob.required_skills ? selectedJob.required_skills : "N/A"}\n`;
      copyText += `Job Description: ${selectedJob.job_description !== null && selectedJob.job_description !== undefined && selectedJob.job_description ? selectedJob.job_description.replace(/<[^>]+>/g, "") : ""}\n`;
    }
    return copyText;
  };

  //end copy details view
  useEffect(() => {
    if (gridRef.current) {
      gridRef.current.addEventListener("scroll", handleToolbarScroll);
    }

    return () => {
      if (gridRef.current) {
        gridRef.current.removeEventListener("scroll", handleToolbarScroll);
      }
    };
  }, []);

  const handleToolbarScroll = () => {
    const yOffset = gridRef.current.scrollTop;
    const triggerScroll = 200; // Adjust as needed

    if (yOffset > triggerScroll) {
      //   setShowToolbar(true);
    } else {
      //   setShowToolbar(false);
    }
  };
  const scrollToSkillMatch = () => {
    if (skillMatchRef.current) {
      gridRef.current.scrollTo({
        top: skillMatchRef.current.offsetTop,
        behavior: "smooth",
      });
    }
  };

  const handleTitle = () => {
    if(window.location.pathname == "/candidates"){
     handleInputChange(selectedJob?.company_name) ;
     setSource("") ;
     setCandidateRole(selectedCandidate?.role)
    }

  }

  const handlesourcelinkClick = (jobLink) => {
    if (jobLink) {
      // Open the jobLink in a new tab
      window.open(jobLink, '_blank');
    } else {
      console.error("Job link is not available");
      alert("Job link is not available");
    }
  };



  return (
    <Box
      sx={{ maxHeight: window.innerHeight - 50, overflowY: "scroll", position: "relative" }}
      ref={gridRef}
    >
      {selectedJob && Object.keys(selectedJob)?.length !== 0 ? (
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <Box sx={{display:"flex",justifyContent:"space-between",width:'50px',float:'right',alignItems:"center"}}>
            <Tooltip title="Job Link">
                <InsertLinkOutlinedIcon style={{ float: "right", fontSize: '15px', marginTop: "12px" }} onClick={() => handlesourcelinkClick(jobDetails?.job_link)} />
            </Tooltip>
            <Tooltip title={copied ? "Copied!" : "Copy"}>
              <ContentCopyIcon style={{ float: "right", marginRight: "5px", fontSize: "12px", marginTop: "10px", cursor: "pointer", color: copied ? "#406882" : undefined, }} onClick={handleCopy} />
              </Tooltip>
            </Box>
            <Card
              sx={{
                borderRadius: "8px",
                boxShadow: "none",
                padding: "10px",
              }}
            >
              <Stack direction="column" gap={2}>
                <Stack direction="column">
                  <Typography
                    component="body"
                    variant={isDesktopLarge ? "h5" : "h6"}
                    sx={{
                      textTransform: "capitalize",
                      fontWeight: 500,
                      fontSize:"20px"
                    }}
                    onClick={()=>handleTitle() }
                  >
                    {selectedJob?.jobtitle}
                  </Typography>
                  <Breadcrumbs separator={<Bullet />} aria-label="breadcrumb">
                    {selectedJob && Object.keys(selectedJob).length !== 0 && (
                      <Typography
                        paragraph
                        onClick={()=> {handleInputChange(selectedJob?.company_name) ; setSource("")}}
                        sx={{
                          margin: 0,
                          fontWeight: 400,
                          textTransform: "capitalize",
                          fontSize: isDesktopLarge ? "0.85rem" : "0.75rem",
                          cursor: "pointer",
                          "&:hover": {
                            textDecoration: "underline",
                          },
                        }}
                      >
                        {selectedJob.company_name}
                      </Typography>
                    )}

                    <Typography
                      paragraph
                      sx={{
                        margin: 0,
                        fontWeight: 400,
                        textTransform: "capitalize",
                        fontSize: isDesktopLarge ? "0.85rem" : "0.75rem",
                      }}
                    >
                      {selectedJob?.location
                        ? selectedJob.location
                        : parseInt(selectedJob.remote) === 1
                        ? "Remote"
                        : "N/A"}
                    </Typography>
                    <Typography
                      paragraph
                      sx={{
                        margin: 0,
                        color: "#757575",
                        fontWeight: 500,
                        fontSize: isDesktopLarge ? "0.85rem" : "0.75rem",
                      }}
                    >
                      {selectedJob.posted_date !== undefined &&
                      selectedJob.posted_date !== null
                        ? moment(selectedJob.posted_date).fromNow() !==
                          "Invalid date"
                          ? moment(selectedJob.posted_date).fromNow()
                          : moment("2022-03-31T06:26:04.138Z").fromNow()
                        : moment("2022-03-31T06:26:04.138Z").fromNow()}
                    </Typography>
                  </Breadcrumbs>
                </Stack>
                <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                  <Stack direction="column" gap={1}>
                    <Tooltip
                      // title={
                      //   <Typography>
                      //     {/* Your complete text here */}
                      //     <BusinessCenterRounded
                      //       sx={{
                      //         height: isDesktopLarge ? "20px" : "18px",
                      //         width: isDesktopLarge ? "20px" : "18px",
                      //         color: "#757575",
                      //         marginRight: "5px",
                      //       }}
                      //     />
                      //     {selectedJob.jobtype_name !== undefined &&
                      //     selectedJob.jobtype_name !== null
                      //       ? selectedJob.jobtype_name
                      //       : "Full Time"}
                      //     {/* &nbsp;&nbsp;
                      //         {selectedJob.noofjobs !== undefined &&
                      //         selectedJob.noofjobs !== null &&
                      //         parseInt(selectedJob.noofjobs) !== 0
                      //           ? `(Positions : ${selectedJob.noofjobs})`
                      //           : "(Positions : 1)"} */}
                      //   </Typography>
                      // }
                      // arrow
                      // placement="top"
                      // enterTouchDelay={500}
                    >
                      <Typography
                        paragraph
                        sx={{
                          margin: 0,
                          display: "flex",
                          alignItems: "end",
                          gap: "2px",
                          fontSize: isDesktopLarge ? "0.85rem" : "0.75rem",
                          minWidth: "80px",
                          maxWidth: isDesktopLarge ? "400px" : "200px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        {/* Your abbreviated content here */}
                        <BusinessCenterRounded
                          sx={{
                            height: isDesktopLarge ? "20px" : "18px",
                            width: isDesktopLarge ? "20px" : "18px",
                            color: "#757575",
                            marginRight: "5px",
                          }}
                        />
                        {selectedJob.jobtype_name !== undefined &&
                        selectedJob.jobtype_name !== null
                          ? selectedJob.jobtype_name
                          : "Full Time"}
                        {/* &nbsp;&nbsp;
                            {selectedJob.noofjobs !== undefined &&
                            selectedJob.noofjobs !== null &&
                            parseInt(selectedJob.noofjobs) !== 0
                              ? `(Positions : ${selectedJob.noofjobs})`
                              : "(Positions : 1)"} */}
                      </Typography>
                    </Tooltip>

                    <Tooltip
                      // title={
                      //   selectedJob?.visatypeName !== undefined &&
                      //   selectedJob?.visatypeName !== null
                      //     ? selectedJob?.visatypeName
                      //     : "N/A"
                      // }
                      arrow
                      placement="top"
                      enterTouchDelay={500}
                    >
                      <Typography
                        paragraph
                        sx={{
                          margin: 0,
                          fontSize: isDesktopLarge ? "0.85rem" : "0.75rem",
                          display: "flex",
                          alignItems: "end",
                          gap: "2px",
                          maxWidth: isDesktopLarge ? "400px" : "200px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                        }}
                      >
                        <FlightRounded
                          style={{
                            height: isDesktopLarge ? "20px" : "18px",
                            width: isDesktopLarge ? "20px" : "18px",
                            color: "#757575",
                            marginRight: "5px",
                          }}
                        />
                        {selectedJob?.visatypeName !== undefined &&
                        selectedJob.visatypeName !== null
                          ? selectedJob.visatypeName
                          : "N/A"}
                      </Typography>
                    </Tooltip>

                    <Typography
                      paragraph
                      sx={{
                        margin: 0,
                        fontSize: isDesktopLarge ? "0.85rem" : "0.75rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "2px",
                      }}
                    >
                      <SchoolRounded
                        style={{
                          height: isDesktopLarge ? "20px" : "18px",
                          width: isDesktopLarge ? "20px" : "18px",
                          color: "#757575",
                          marginRight: "5px",
                        }}
                      />
                      {selectedJob?.qualifications !== undefined &&
                      selectedJob.qualifications !== null &&
                      selectedJob.qualifications !== ""
                        ? selectedJob.qualifications
                        : "N/A"}
                    </Typography>
                    <Typography
                      paragraph
                      sx={{
                        margin: 0,
                        fontSize: isDesktopLarge ? "0.85rem" : "0.75rem",
                        display: "flex",
                        alignItems: "center",
                        gap: "2px",
                      }}
                    >
                      <WorkHistoryRounded
                        style={{
                          height: isDesktopLarge ? "20px" : "18px",
                          width: isDesktopLarge ? "20px" : "18px",
                          color: "#757575",
                          marginRight: "5px",
                        }}
                      />
                      {selectedJob?.experience === "0"
                        ? "0 - 3 Years"
                        : selectedJob?.experience}
                    </Typography>
                    <Tooltip
                      // title="skilss"
                      arrow
                      placement="top"
                      enterTouchDelay={500}
                    >
                      <Typography
                        paragraph
                        sx={{
                          margin: 0,
                          fontSize: isDesktopLarge ? "0.85rem" : "0.75rem",
                          display: "flex",
                          alignItems: "center",
                          gap: "2px",
                          cursor: "pointer",
                          maxWidth: isDesktopLarge ? "400px" : "200px",
                          whiteSpace: "nowrap",
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          "&:hover": {
                            textDecoration: "underline",
                          },
                        }}
                        onClick={scrollToSkillMatch}
                      >
                        <ChecklistRtlRounded
                          style={{
                            height: isDesktopLarge ? "20px" : "18px",
                            width: isDesktopLarge ? "20px" : "18px",
                            color: "#757575",
                            marginRight: "5px",
                          }}
                        />
                        {selectedJob.required_skills ? selectedJob.required_skills:"N/A"}
                      </Typography>
                    </Tooltip>
                  </Stack>
                </Box>
              </Stack>
            </Card>
          </Grid>
          <Grid item xs={12}>
            <Card sx={{ boxShadow: "none", padding: "10px" }}>
              <Typography paragraph sx={{ fontWeight: 500 }}>
                About the job
              </Typography>
              <Typography paragraph>
                {selectedJob.job_description !== null &&
                selectedJob.job_description !== undefined &&
                selectedJob.job_description
                  ? !selectedJob.job_description.includes("ahref") &&
                    !selectedJob.job_description.includes("divclass") &&
                    !selectedJob.job_description.includes("aclass") &&
                    !selectedJob.job_description.includes("pclass") &&
                    !selectedJob.job_description.includes("liclass")
                    ? parse(selectedJob.job_description)
                    : selectedJob.job_description.replace(/<[^>]+>/g, "")
                  : ""}
              </Typography>
            </Card>
          </Grid>
        </Grid>
      ) : (
          <Card>No Data Found...</Card>
          // <Card><Loadingjobdetail/></Card>

      )}
    </Box>
  );
};

export default JobDetails;
